import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgCheckboxComponent } from './pg-checkbox.component';
import { PgCheckboxFactoryComponent } from './pg-checkbox-factory/pg-checkbox-factory.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [PgCheckboxComponent, PgCheckboxFactoryComponent],
  exports: [PgCheckboxComponent, PgCheckboxFactoryComponent],
})
export class PgCheckboxModule {}
